import moment from "moment";
moment.locale("es");

export const helpers = {
  dateFromNow: (timestamp) => {
    return moment(timestamp).fromNow();
  },
};
